// Interceptor global de autenticação.
//
// Faz um "patch" no window.fetch: toda resposta da API passa por aqui antes
// de chegar nas telas. Se o backend responder 401 (sessão ausente, inválida
// ou expirada) e o usuário se achava logado, a sessão é limpa e ele é levado
// ao login com um aviso claro — em vez de a tela falhar em silêncio.
//
// Só age em 401. O 403 (autenticado, mas sem permissão) NÃO dispara redirect:
// é um problema de autorização que a própria tela deve tratar.
//
// Carregado uma única vez no boot do app (ver src/index.js).

const fetchOriginal = window.fetch.bind(window);

// Trava: várias chamadas podem voltar 401 ao mesmo tempo (o app dispara
// muitas requisições em paralelo). Sem isso, cada uma tentaria redirecionar.
let redirecionando = false;

window.fetch = async (...args) => {
  const resposta = await fetchOriginal(...args);

  // Só nos interessa 401 de quem se achava logado (tinha token guardado).
  if (resposta.status === 401 && localStorage.getItem('authToken')) {
    // A própria tela de login também devolve 401 (senha errada). Nesse caso
    // não redirecionamos — a tela mostra o erro normalmente.
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const ehLogin = url.includes('/api/login');

    if (!ehLogin && !redirecionando) {
      redirecionando = true;
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');

      // Guarda ONDE a pessoa estava para o Login trazê-la de volta depois de
      // reautenticar. É ESTE o elo que o `state.from` do React Router NÃO
      // consegue manter: o redirect abaixo é "duro" (window.location) e recarrega
      // o app do zero, apagando todo o estado em memória — inclusive o state.from.
      // Sem isto, quem escaneia o QR da etiqueta (/q/:codigo) com a sessão de 8h
      // já vencida — o caso comum no celular do gerente, onde o token velho ainda
      // está no localStorage — reautentica e cai na Home, perdendo o equipamento
      // que o adesivo já tinha identificado. O sessionStorage sobrevive ao reload
      // e é por aba (some quando a aba fecha).
      // ⚠️ Não guardamos a própria /login nem as telas públicas de auth: voltar
      //    para elas depois de entrar não faz sentido.
      const caminho = window.location.pathname + window.location.search;
      const ehTelaDeAuth = /^\/(login|esqueci-senha|redefinir-senha|vagas|inscricao)/.test(window.location.pathname);
      try {
        if (!ehTelaDeAuth) sessionStorage.setItem('redirectAposLogin', caminho);
      } catch (e) {
        // Modo privado de alguns navegadores barra o sessionStorage — seguimos
        // sem o retorno (a pessoa cai no landing padrão, como era antes).
      }

      // Flag lido pela tela de login para exibir o aviso de sessão expirada.
      sessionStorage.setItem('sessaoExpirada', '1');
      // Redirect "duro": recarrega o app limpo no login (estado zerado).
      window.location.href = '/login';
    }
  }

  return resposta;
};
